import { CurrencyEnum, LocaleEnum } from '@systemeio/types'
import { centsToUnits, units } from '@systemeio/util'
import { AffiliateSumType } from 'modules/affiliate/types/affiliate-statistic-interface'
import { currencyFormat } from 'shared/utils/currency-format'

export const getAffiliateSum = (
  amountObj: AffiliateSumType,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
) =>
  selectedCurrency
    ? currencyFormat(centsToUnits(amountObj[selectedCurrency]), selectedCurrency, locale)
    : currencyFormat(units(0), CurrencyEnum.EURO, locale)
